import Button from './_button.js'
import Text from './_text.js'
import AbsolutePane from './_absolute-pane.js'
import HideablePane from './_hideable-pane.js'
import RotatableImage from './_rotatable-image.js'
import FlexPane from './_flex-pane.js'
import FlexContainerBase from './_flex-container-base.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'

export default {
  name: 'Dropdown',
  values: {
    limitNavigation: false,
    _mobile_limitNavigation: true,
    fitInViewPort: false,
    controlButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            alignItems: 'center',
            minWidth: '100%',
            padding: '0 8px',
          },
        },
      },
    },
    controlButtonSelected: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            alignItems: 'center',
            minWidth: '100%',
            padding: '0 8px',
          },
        },
      },
    },
    controlText: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    controlTextSelected: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    menuItem: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            padding: '0 8px',
            whiteSpace: 'normal',
            minHeight: '32px',
            _mobile_minHeight: '40px',
            minWidth: '100%',
            alignItems: 'center',
          },
        },
      },
    },
    menuItemText: {
      configSet: Text,
      configValues: {},
    },
    subHeaderText: {
      configSet: Text,
      configValues: {
        container: {
          padding: '8px',
        },
      },
    },
    menuContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          top: '100%',
          left: '0px',
          minWidth: '100%',
          zIndex: 600,
        },
      },
    },
    itemsContainer: {
      configSet: HideablePane,
      configValues: {
        style: {
          hidden: {
            opacity: 1,
          },
        },
      },
    },
    rotation: {
      configSet: RotatableImage,
      configValues: {
        image: {
          src: 'chevron-up',
          style: {
            minWidth: '20px',
            minHeight: '10px',
            padding: '0 6px',
          },
        },
      },
    },
    rotationSelected: {
      configSet: RotatableImage,
      configValues: {
        image: {
          src: 'chevron-up',
          style: {
            minWidth: '20px',
            minHeight: '10px',
            padding: '0 6px',
          },
        },
      },
    },
    columnContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          alignItems: 'flex-start',
        },
      },
    },
    style: {
      rootContainer: {
        position: 'relative',
        height: '32px',
        _mobile_height: '40px',
        width: 'auto',
        $mixin: [
          {
            configSet: FlexContainerBase,
          },
          {
            configSet: FlexItemBase,
          },
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
    },
  },
  meta: {
    extendable: false,
  },
}
